import React, { useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

import Footer from '../components/Footer';

import '../static/css/aboutHotelPage.css';

import AboutHotelFirstImage from '../assets/img/hotel-page/about-hotel-first-image.jpg';
import AboutHotelSecondImage from '../assets/img/hotel-page/about-hotel-second-image.jpg';
import HotelRestaurantLargeImage from '../assets/img/hotel-page/hotel-restaurant-large.jpg';
import HotelRestaurantSquareImage from '../assets/img/hotel-page/hotel-restaurant-square.jpg';

import SaunaService from '../assets/img/hotel-page/hotel-services/sauna.jpg';
import LiftService from '../assets/img/hotel-page/hotel-services/lift.jpg';
import KidsRoomService from '../assets/img/hotel-page/hotel-services/kids-room.jpg';

import OazaLogo from '../assets/img/oaza-logo.png';

import { ReactComponent as WhiteLogo } from '../assets/white-logo-text.svg';

const AboutHotelPage = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const heroParallax = gsap.timeline({
            scrollTrigger: {
                trigger: '.hero-section',
                start: '20% top',
                end: 'bottom top',
                scrub: true
            }
        });
        heroParallax.to('.hotel-hero-section-background-image', {backgroundPosition: "50% 150%"});
    }, [])

  return (
    <div className='bg-color-dark'>
        <section className='container-fluid m-0 p-0 position-relative d-flex flex-column justify-content-around align-items-center z-0 hero-section' style={{minHeight: "100vh"}}>
            <div className='col-12 position-absolute z-1 hotel-hero-section-background-image' style={{height: "100vh"}}></div>

            <div className='col-11 col-lg-10 position-relative z-2 mx-auto mb-5' style={{marginTop: "15rem"}}>
                <h1 className='text-title-5 text-white text-center font-jost-light mb-0 pb-0'>OAZA HOTEL</h1>
                <p className='text-white text-wrap text-center font-cormorant-regular fs-5 py-0 my-0 lhs-0'>{t('home_page_hero_section_catch_phrase')}</p>
            </div>

            <div className='col-11 position-relative z-2 d-flex h-auto justify-content-center justify-content-md-center mb-5 mt-5 pb-4'>
                <a href='https://www.booking.com/hotel/ua/oaza-iasinia.cs.html' target="_blank" className='text-white px-5 fs-5 menu-btn font-jost-light' style={{ padding: "2.3%"}}>
                <span className="frame" aria-hidden="true"></span>
                
                {t('book_room_button')}
                </a>
            </div>
        </section>

        <section className='col-12 bg-soft-white d-flex flex-row about-hotel-section' style={{minHeight: "125vh"}}>
            <div className='col-md-6 d-flex justify-content-center align-items-start'>
                <div className='col-10  col-sm-7'>
                    <h1 className='text-dark-color font-jost-regular about-hotel-section-title'>{t('hotel_page_about_hotel_title')}</h1>
                    <div className='col-12 bg-dark mb-5' style={{height: "2px"}}></div>
                    <p className='font-montserrat-regular about-hotel-section-description'><Trans i18nKey="hotel_page_about_hotel_description" components={{ br: <br/> }} /></p>
                </div>
            </div>

            <div className='col-6 position-relative about-hotel-images-container'>
                <div className='col-10 col-lg-8 about-hotel-section-first-image'>
                    <img src={AboutHotelFirstImage} alt="about hotel" className='img-fluid' />
                </div>

                <div className='col-8 col-lg-7 col-xl-6 about-hotel-section-second-image p-3'>
                    <img src={AboutHotelSecondImage} alt="about hotel" className='img-fluid' />
                </div>
            </div>
        </section>

        <section className='col-12 d-flex justify-content-center align-items-center reception-section'>
            <div className='col-12 d-flex flex-column justify-content-center align-items-center'>
                {/* <img src={OazaLogo} alt="Oaza Logo" className='img-flui mb-2' /> */}
                <WhiteLogo className='col-lg-7' />

                <div className='col-11 col-sm-10 col-md-8 col-lg-6 px-3 mt-5'>
                    <p className='font-montserrat-light text-white text-center reception-section-description'>{t('hotel_page_about_reception_description')}</p>
                </div>
            </div>
        </section>

        <section className='col-12 bg-soft-white d-flex flex-column justify-content-start align-items-center services-section pb-5' style={{minHeight: "98vh"}}>
            <p className='fs-5 font-jost-regular'>{t('hotel_page_discover_hotel_title')}</p>

            <div className='col-11 col-sm-9 col-md-8 col-lg-7 col-xl-5 px-4'>
                <p className='text-center font-montserrat-regular service-description'>{t('hotel_page_discover_hotel_description')}</p>
            </div>

            <div className='col-md-11 col-lg-9 col-xl-8 col-xxl-7 d-flex flex-wrap flex-md-row justify-content-around row-gap-4 mt-5 mb-4'>
                <div className='col-8 col-sm-5 col-md-4 px-3'>
                    <img src={LiftService} alt="sauna" className='img-fluid' />

                    <div className='mt-3'>
                        <p className='fs-6 mb-2 service-title'>{t('hotel_page_discover_hotel_own_pullers_title')}</p>
                        <div className='col-7 bg-dark' style={{height: "1px"}}></div>
                        <p className='mt-2 pe-1 service-item-description'><Trans i18nKey="hotel_page_discover_hotel_own_pullers_description" components={{ span: <span className='fw-bold'></span> }} /></p>
                    </div>
                </div>

                <div className='col-8 col-sm-5 col-md-4 px-3'>
                    <img src={SaunaService} alt="sauna" className='img-fluid' />

                    <div className='mt-3'>
                        <p className='fs-6 mb-2 service-title'>{t('hotel_page_discover_hotel_sauna_title')}</p>
                        <div className='col-7 bg-dark' style={{height: "1px"}}></div>
                        <p className='mt-2 pe-1 service-item-description'><Trans i18nKey="hotel_page_discover_hotel_sauna_description" components={{ br: <br/> }} /></p>
                    </div>
                </div>

                <div className='col-8 col-sm-5 col-md-4 px-3'>
                    <img src={KidsRoomService} alt="sauna" className='img-fluid' />

                    <div className='mt-3'>
                        <p className='fs-6 mb-2 service-title'>{t('hotel_page_discover_hotel_playroom_title')}</p>
                        <div className='col-7 bg-dark' style={{height: "1px"}}></div>
                        <p className='mt-2 pe-1 service-item-description'><Trans i18nKey="hotel_page_discover_hotel_playroom_description" components={{ br: <br/> }} /></p>
                    </div>
                </div>
            </div>
        </section>

        <section className='container-fluid p-0 d-flex justify-content-end align-items-end hotel-restaurant-section'>
            <div className='col-11 col-md-10 col-lg-9 col-xl-8 bg-soft-white m-0 d-flex flex-row justify-content-between align-items-center' style={{height: "85%"}}>
                <div className='col-12 col-md-4 d-flex justify-content-center align-items-center'>
                    <div className='col-11 col-sm-9 d-flex flex-column justify-content-center align-items-center'>
                        <p className='fs-5 mb-2 text-colour-skin hotel-restaurant-title'>{t('hotel_page_about_restaurant_title')}</p>
                        <div className='col-5 px-5 mx-5' style={{height: "1.3px", backgroundColor: "#1f1f1f6f"}}></div>
                        <p className='text-center font-montserrat-regular hotel-restaurant-description px-2 mt-2'>{t('hotel_page_about_restaurant_description')}</p>

                        <a href='/restaurant/' className='text-dark text-center mt-4 hotel-restaurant-button'>{t('hotel_page_about_restaurant_link_button')}</a>
                    </div>
                </div>

                <div className='col-8 hotel-restaurant-image-container'>
                    <img src={HotelRestaurantSquareImage} alt="hotel restaurant" className='img-fluid' />
                </div>
            </div>
        </section>

        <section className='container-fluid bg-soft-white d-flex justify-content-center align-items-center pt-5' style={{minHeight: "80vh"}}>
            <div className='col-11 col-lg-9 bg-white py-5 d-flex flex-column justify-content-center align-items-center'>
                <p className='fs-3 mb-2 text-colour-skin font-jost-regular'>{t('hotel_page_our_philosophy_title')}</p>
                <div className='col-1' style={{height: "1.3px", backgroundColor: "#1f1f1fa0", width: "11%"}}></div>

                <p className='col-11 col-sm-12 text-center font-montserrat-regular mt-4 philosophy-text'>{t('hotel_page_our_philosophy_description')}</p>
            
                <div className='col-11 col-md-10 mt-3 d-flex flex-column flex-md-row justify-content-around align-items-center align-items-md-start'>
                    <div className='col-sm-11 col-md-6 px-3'>
                        <p className='text-center philosophy-text mb-0'>{t('hotel_page_our_philosophy_text_1')}</p>
                    </div>

                    <div className='col-10 my-4 hotel-restaurant-mobile-separation-line' style={{height: "1px", backgroundColor: "#1f1f1fa0"}}></div>

                    <div className='col-sm-11 col-md-6 px-3'>
                        <p className='text-center philosophy-text'>{t('hotel_page_our_philosophy_text_2')}</p>
                    </div>
                </div>
            </div>
        </section>

        <section className='container-fluid bg-soft-white p-0'>
            <p className='font-jost-regular text-center pb-3 pt-5 rooms-section-title'>{t('hotel_page_rooms_title')}</p>

            <div className='col-12 rooms-section-action-container d-flex justify-content-center align-items-center'>
                <a href='/rooms/' className='text-white font-jost-light text-center menu-btn hotel-rooms-button'><span className="frame" aria-hidden="true"></span> {t('hotel_page_rooms_button')}</a>
            </div>
        </section>

        <Footer />
    </div>

    // <div className='bg-color-dark'>
    //     <section className='container-fluid d-flex flex-column justify-content-around align-items-center mb-5' style={{height: "100vh"}}>
    //         <div className='col-xl-11 h-100 h-xxl-65 d-flex flex-column flex-xl-row justify-content-start justify-content-xl-between align-items-center align-items-xl-start header-offset'>
    //             <div className='col-md-11 col-lg-10 col-xl-5 mb-sm-5'>
    //                 <h1 className='text-color-dark-skin font-mont-semibold text-title-2 fw-bold'>Про готель</h1>
    //                 <p className='text-white text-responsive-1 font-mont-light'>Наш готель створений для тих, хто цінує затишок, сервіс і справжню атмосферу гірського відпочинку. Тут однаково комфортно почуватимуться як досвідчені лижники та сноубордисти, так і сім’ї з дітьми, пари чи компанії друзів, які приїхали насолодитися природою та активним дозвіллям. <br/><br/> Протягом багатьох років ми приймаємо гостей, які хочуть насолодитися чудовим снігом, гірськими пейзажами і бездоганним обслуговуванням. Тож пропонуємо вам:</p>
    //             </div>

    //             <div className='col-11 col-sm-10 col-md-9 col-xl-6 d-flex flex-row justify-content-end column-gap-4 about-page-hero-image-section'>
    //                 <div className='col-4 h-100 about-page-vertical-hero-image'></div>
    //                 <div className='col-12 col-sm-7 h-100 d-flex flex-column row-gap-4'>
    //                     <div className='about-page-horizontal-upper-hero-image'></div>
    //                     <div className='about-page-horizontal-lower-hero-image'></div>
    //                 </div>
    //             </div>
    //         </div>
    //     </section>

    //     <section className='container-fluid p-0 m-0 d-flex justify-content-center align-items-center position-relative overflow-hidden svg-section'>
    //         <div className='col-11 col-xl-10 d-flex justify-content-center align-items-center'>
    //             <Line className="about-hotel-desktop-svg" />
    //             <LineMobile className="about-hotel-mobile-svg" />
    //             {/* <div className='col-12 col-md-7 d-flex flex-column justify-content-around justify-content-md-between align-items-center align-items-md-start position-absolute top-0 about-page-animated-svg-section-text-container'>
    //                 <div className='col-8 col-sm-7 col-xl-6 about-page-animated-svg-section-text'>
    //                     <h1 className='text-color-dark-skin font-mont-semibold'>Сауна</h1>
    //                     <p className='text-white font-mont-light about-page-animated-svg-section-description-text mb-0'>В готелі можна розслабитись є невелика сауна (на 4 особи) з контрастним басейном та куточком, для відпочинку.</p>
    //                     <p className='text-color-dark-skin font-mont-semibold about-page-animated-svg-section-description-text'>Вартість 600грн/год.</p>
    //                 </div>

    //                 <div className='col-8 col-sm-7 col-md-9 col-xl-7 align-self-center align-self-md-end about-page-animated-svg-section-text'>
    //                     <h1 className='text-color-dark-skin font-mont-semibold'>Ресторан</h1>
    //                     <p className='text-white font-mont-light about-page-animated-svg-section-description-text'>Відвідавши наш комплекс, ви маєте можливість насолодитися стравами гуцульської, української та європейської кухні в найвисокогірнішому ресторані України. Скуштувати ароматний трав’яний чай на відкритій терасі, з якої відкривається неймовірний пейзаж на вершини навколишніх гір.</p>
    //                 </div>

    //                 <div className='col-8 col-sm-7 col-xl-6 about-page-animated-svg-section-text'>
    //                     <h1 className='text-color-dark-skin font-mont-semibold'>Паркінг</h1>
    //                     <p className='text-white font-mont-light about-page-animated-svg-section-description-text'>Місце, щоб зручно розсташувати свій автомобіль одразу біля готелю.</p>
    //                 </div>
    //             </div> */}
    //         </div>
    //     </section>

    //     <section className='d-flex justify-content-center overflow-x-hidden' id='sectioned-images-section' style={{minHeight: "60vh"}}>
    //         <div className='col-11 h-100 d-flex flex-row justify-content-center column-gap-5'>
    //             <div className='col-6 col-md-5 col-lg-3 col-xxl-2 about-hotel-page-sectioned-images sectioned-image-from-top'></div>
    //             <div className='col-6 col-md-5 col-lg-3 col-xxl-2 about-hotel-page-sectioned-images sectioned-image-from-bottom'></div>
    //             <div className='col-6 col-md-5 col-lg-3 col-xxl-2 about-hotel-page-sectioned-images sectioned-image-from-top'></div>
    //             <div className='col-6 col-md-5 col-lg-3 col-xxl-2 about-hotel-page-sectioned-images sectioned-image-from-bottom'></div>
    //             <div className='col-6 col-md-5 col-lg-3 col-xxl-2 about-hotel-page-sectioned-images sectioned-image-from-top'></div>
    //         </div>
    //     </section>

    //     <section className='container-fluid m-0 pb-5 d-flex flex-column align-items-center'>
    //         <div className='d-flex flex-column align-items-center'>
    //             <h1 className='text-white text-center text-md-start text-title-2 font-libre-caslon mb-5'>Створюйте незабутні моменти разом з нами</h1>
    //             <ArrowDown />
    //         </div>
            
    //         <a href='/rooms/' className='bg-transparent text-white button-hover-right-fill-skin border border-color-skin px-5 py-2 fs-2 my-5 buton-hover-skin'>Номери</a>
    //     </section>

    //     <Footer />
    // </div>
  )
}

export default AboutHotelPage